// PDP add-ons (snippets/block-buy-x-get-y-offer.liquid). Each Add button puts its item in the cart
// straight away, tagged with the _pdp_offer line property (the pdp_offer metaobject id) so add-on
// lines can be traced back to the offer. Independent of the main Add to Cart and of free gifts.
if (!customElements.get('pdp-addons')) {
  customElements.define(
    'pdp-addons',
    class PdpAddons extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = (event) => {
        const more = event.target.closest('[data-pdp-addons-more]');
        if (more) {
          this.querySelectorAll('[data-pdp-addon][hidden]').forEach((item) => (item.hidden = false));
          more.remove();
          return;
        }

        const button = event.target.closest('[data-pdp-addon-add]');
        if (button && !button.classList.contains('is-added')) this.add(button);
      };

      add(button) {
        button.disabled = true;
        return window.aoCartActions.run(() => this.performAdd(button));
      }

      async performAdd(button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        const status = this.querySelector('[data-pdp-addons-status]');
        const title = button.closest('[data-pdp-addon]')?.querySelector('.pdp-addon__title')?.textContent.trim();

        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _pdp_offer: this.dataset.offerId } }],
            }),
          });
          if (!response.ok) throw new Error((await response.json()).description || response.statusText);

          button.classList.add('is-added');
          button.querySelector('[data-label-default]').hidden = true;
          button.querySelector('[data-label-added]').hidden = false;
          if (status) status.textContent = `${title} added to cart`;
          await this.updateCartCount();
        } catch (error) {
          button.disabled = false;
          if (status) status.textContent = `${title} could not be added. ${error.message}`;
          console.error(error);
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      async updateCartCount() {
        const bubble = document.querySelector('.cart-count-bubble');
        if (!bubble) return;
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        bubble.querySelector('span[aria-hidden="true"]')?.replaceChildren(String(cart.item_count));
        bubble.querySelector('span.visually-hidden')?.replaceChildren(`${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`);
      }
    }
  );
}
